/** Textos do criador. Regras e números ficam em @besenliga/shared; aqui só o que aparece na tela. */
import type { ClipId } from "@besenliga/anim";
import type { Position, ProfileProblem } from "@besenliga/shared";
import { ROSTER_MAX, type KitId } from "./roster";

export const POSITION_INFO: Record<
  Position,
  { label: string; role: string; gear: string; clip: ClipId; move: string }
> = {
  artilheiro: {
    label: "Artilheiro",
    role: "Marca gols com a Pelota",
    gear: "braçadeira",
    clip: "arremesso",
    move: "Ver arremesso",
  },
  goleiro: {
    label: "Goleiro",
    role: "Defende os três aros",
    gear: "capacete",
    clip: "defesa",
    move: "Ver defesa",
  },
  batedor: {
    label: "Batedor",
    role: "Rebate os Petardos",
    gear: "taco",
    clip: "rebatida",
    move: "Ver rebatida",
  },
  cacador: {
    label: "Caçador",
    role: "Persegue a Faísca",
    gear: "capa",
    clip: "mergulho",
    move: "Ver mergulho",
  },
};

export const KIT_LABELS: Record<KitId, string> = {
  "corujas-campinas": "Corujas de Campinas",
  "lobos-guaiba": "Lobos do Guaíba",
};

export const PROBLEM_TEXT: Record<ProfileProblem, string> = {
  "nome-curto": "O nome precisa de pelo menos 2 letras.",
  "nome-longo": "O nome pode ter no máximo 20 caracteres.",
  "nome-caracteres": "Use só letras, espaço, hífen, ponto e apóstrofo, começando por uma letra.",
  numero: "Escolha um número de 1 a 99.",
  posicao: "Escolha uma posição.",
  corpo: "Escolha sexo, altura e biotipo.",
  aparencia: "Alguma opção de aparência não existe mais. Escolha de novo.",
};

export const SAVE_ERROR_TEXT = {
  invalido: "Corrija a ficha antes de salvar.",
  cheio: `Seu elenco já tem ${ROSTER_MAX} atletas. Exclua um para salvar outro.`,
  armazenamento: "Este navegador não deixou salvar (aba anônima ou armazenamento bloqueado).",
} as const;

export const hexCss = (hex: number) => `#${hex.toString(16).padStart(6, "0")}`;
